import React from "react";

interface HighRiskMarkerProps {
  height?: number;
}

const HighRiskMarker: React.FC<HighRiskMarkerProps> = ({ height = 44 }) => (
  <svg
    className="high-risk-marker"
    width={3}
    height={height}
    viewBox={`0 0 3 ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x={0} y={0} width={3} height={height} />
  </svg>
);

export default HighRiskMarker;
